import React from "react";
import "./styles.css";

export const CustomTable = ({ node, ...props }) => <table className="custom-table" {...props} />;
